import { RegistryDefinition } from './registry.types';

/**
 * Реестр заявок (`/core/orders`).
 */
export const ORDERS_REGISTRY: RegistryDefinition = {
    id: 'orders',
    title: 'Заявки',
    path: '/orders',
    queryMode: 'hash',
    filters: [
        {
            key: 'search',
            label: 'Поиск',
            description: 'Текст поиска по заявкам. Используется вместе с searchByWhat.',
            valueType: 'string',
        },
        {
            key: 'searchByWhat',
            label: 'Поиск',
            description:
                'Критерий поиска: BY_ID (по ID заявки), BY_STRING (по содержимому), BY_EXTERNAL_ID (по внешнему ID позиций), BY_REQUEST_ID (по ID запросов), BY_PROJECT (по наименованию проекта), BY_COMMENT (по комментарию/наименованию), BY_DELIVERY_ADDRESS (по адресу доставки).',
            valueType: 'enum',
            enumValues: [
                'BY_ID',
                'BY_STRING',
                'BY_EXTERNAL_ID',
                'BY_REQUEST_ID',
                'BY_PROJECT',
                'BY_COMMENT',
                'BY_DELIVERY_ADDRESS',
            ],
        },
        {
            key: 'state',
            label: 'Статус',
            description:
                'Статус заявки: ACTIVE (В работе), COMPLETE (Выполнена), DELETED (Удалена), DRAFT (Черновик), OUTSTANDING (Отложена), ACCEPTED (Согласована), IN_ACCEPTATION (На согласовании), NOT_ACCEPTED (Отклонена).',
            valueType: 'enum',
            enumValues: [
                'ACTIVE',
                'COMPLETE',
                'DELETED',
                'DRAFT',
                'OUTSTANDING',
                'ACCEPTED',
                'IN_ACCEPTATION',
                'NOT_ACCEPTED',
            ],
        },
        {
            key: 'project',
            label: 'Проект',
            description: 'ID проекта.',
            valueType: 'id',
        },
        {
            key: 'showInactiveProjects',
            label: 'Проект',
            description: 'Показывать неактивные проекты в фильтре (true).',
            valueType: 'boolean',
        },
        {
            key: 'creator',
            label: 'Создатель',
            description: 'ID создателя заявки.',
            valueType: 'id',
        },
        {
            key: 'creationDateFrom',
            label: 'Дата создания',
            description: 'Начало периода даты создания (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'creationDateTo',
            label: 'Дата создания',
            description: 'Конец периода даты создания (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'fromBudget',
            label: 'Тип заявки',
            description: 'Тип заявки из бюджета: true или false.',
            valueType: 'boolean',
        },
        {
            key: 'noResponsible',
            label: 'Тип заявки',
            description: 'Только заявки без исполнителя (true).',
            valueType: 'boolean',
        },
        {
            key: 'acceptedDateFrom',
            label: 'Дата согласования',
            description: 'Начало периода даты согласования (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'acceptedDateTo',
            label: 'Дата согласования',
            description: 'Конец периода даты согласования (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'category',
            label: 'Товарная категория',
            description: 'ID товарной категории.',
            valueType: 'id',
        },
        {
            key: 'acceptors',
            label: 'Согласователь',
            description: 'ID согласователя.',
            valueType: 'id',
        },
        {
            key: 'creatorCompany',
            label: 'Компания создателя',
            description: 'ID компании создателя.',
            valueType: 'id',
        },
        {
            key: 'responsible',
            label: 'Исполнитель',
            description: 'ID исполнителя.',
            valueType: 'id',
        },
        {
            key: 'payers',
            label: 'Плательщик',
            description: 'ID плательщика.',
            valueType: 'id',
        },
        {
            key: 'consignees',
            label: 'Грузополучатель',
            description: 'ID грузополучателя.',
            valueType: 'id',
        },
        {
            key: 'finishDateFrom',
            label: 'Требуемая дата поставки',
            description: 'Начало периода требуемой даты поставки (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'finishDateTo',
            label: 'Требуемая дата поставки',
            description: 'Конец периода требуемой даты поставки (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'workDateFrom',
            label: 'Дата передачи в работу',
            description: 'Начало периода даты передачи в работу (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'workDateTo',
            label: 'Дата передачи в работу',
            description: 'Конец периода даты передачи в работу (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'onlyDeferred',
            label: 'Только отложенные',
            description: 'Только отложенные заявки (true).',
            valueType: 'boolean',
        },
        {
            key: 'deferredDateFrom',
            label: 'Только отложенные',
            description: 'Начало периода даты отложения (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'deferredDateTo',
            label: 'Только отложенные',
            description: 'Конец периода даты отложения (YYYY-MM-DD).',
            valueType: 'date',
        },
        {
            key: 'templates',
            label: 'Шаблон',
            description: 'ID шаблона заявки.',
            valueType: 'id',
        },
        {
            key: 'hasNew',
            label: 'Есть необработанные позиции',
            description: 'Заявки с необработанными позициями (true). Часто сочетается с state=ACTIVE.',
            valueType: 'boolean',
        },
        {
            key: 'notAllOnAcceptance',
            label: 'Не все позиции отправлены на согласование',
            description: 'Не все позиции отправлены на согласование (true). Часто сочетается с state=ACTIVE.',
            valueType: 'boolean',
        },
        {
            key: 'hasWaitingWithoutOffer',
            label: 'Есть позиции без ответа и без счёта',
            description:
                'Позиции, по которым отправлены запросы, но нет ответа/счёта (true). Часто сочетается с state=ACTIVE.',
            valueType: 'boolean',
        },
        {
            key: 'hasWaiting',
            label: 'Есть позиции, ожидающие ответа',
            description: 'Есть позиции, ожидающие ответа (true).',
            valueType: 'boolean',
        },
        {
            key: 'notAllAccepted',
            label: 'Не все позиции согласованы',
            description: 'Не все позиции согласованы (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasWarehouse',
            label: 'Есть позиции на складе',
            description: 'Есть позиции на складе (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasNotAccepted',
            label: 'Не на все позиции есть согласованный счёт',
            description: 'Не на все позиции есть согласованный счёт (true).',
            valueType: 'boolean',
        },
        {
            key: 'hasOverduePayment',
            label: 'Есть просроченные платежи',
            description: 'Есть просроченные платежи (true).',
            valueType: 'boolean',
        },
        {
            key: 'withoutComments',
            label: 'Без заметок',
            description: 'Заявки без заметок (true).',
            valueType: 'boolean',
        },
        {
            key: 'orderBy',
            label: 'Сортировка',
            description:
                'Сортировка по возрастанию. Допустимые столбцы: id, name, project-name, creator, responsible, finishDate.',
            valueType: 'enum',
            enumValues: ['id', 'name', 'project-name', 'creator', 'responsible', 'finishDate'],
        },
        {
            key: 'orderByDesc',
            label: 'Сортировка',
            description:
                'Сортировка по убыванию. Допустимые столбцы: id, name, project-name, creator, responsible, finishDate.',
            valueType: 'enum',
            enumValues: ['id', 'name', 'project-name', 'creator', 'responsible', 'finishDate'],
        },
    ],
};
